export function setLocalDatabaseVersion(version: number) {
  localStorage.setItem('local-database-version', String(version));
}
